import React from 'react';
import SOC from './Soc';
import { useNavigate } from 'react-router-dom';
import Footer from '../Footer/Footer';
import './SocPage.css';

/**
 * SocPage — wraps the SOC component (originally a modal) as a full
 * standalone page accessible at /soc.
 *
 * isOpen is always true since we are on the dedicated page.
 * onClose navigates back to the dashboard (home).
 */
const SocPage = () => {
    const navigate = useNavigate();

    const handleClose = () => {
        navigate('/');
    };

    return (
        <>
            <div className="soc-page-wrapper">
                <SOC isOpen={true} onClose={handleClose} pageMode />
            </div>
            <Footer />
        </>
    );
};

export default SocPage;
